import { TransportMode, FreightLegType } from '@/features/master-data/types/freight-route.types';

export type ChargeMethod = 'CBM' | 'KG' | 'FLAT' | 'MANUAL';
export type SurchargeType = 'PERCENTAGE' | 'FLAT';

export interface QuoteFreightSurcharge {
  id: string;
  quoteFreightLegId: string;
  concept: string;
  type: SurchargeType;
  value: number;
  calculatedAmount: number;
}

export interface QuoteFreightLeg {
  id: string;
  quoteId: string;
  legOrder: number;
  origin: string;
  destination: string;
  transportMode: TransportMode;
  legType: FreightLegType;
  providerId: string | null;
  chargeMethod: ChargeMethod;
  ratePerCbm: number;
  ratePerKg: number;
  flatRate: number;
  manualAmount: number;
  minimumCharge: number | null;
  hasInsurance: boolean;
  insuranceRate: number;
  estimatedDays: number | null;
  calculatedAmount: number;
  includedByIncoterm: boolean;
  sourceRouteLegId: string | null;
  surcharges: QuoteFreightSurcharge[];
}

export interface CreateQuoteFreightLegData {
  legOrder: number;
  origin: string;
  destination: string;
  transportMode: TransportMode;
  legType: FreightLegType;
  providerId?: string | null;
  chargeMethod: ChargeMethod;
  ratePerCbm?: number;
  ratePerKg?: number;
  flatRate?: number;
  manualAmount?: number;
  minimumCharge?: number | null;
  hasInsurance?: boolean;
  insuranceRate?: number;
  estimatedDays?: number | null;
  surcharges?: { concept: string; type: SurchargeType; value: number }[];
}

export interface FreightCalculationResult {
  totalFreight: number;
  totalInsurance: number;
  paysInsurance: boolean;
  paysDuties: boolean;
  legs: {
    id: string;
    baseAmount: number;
    surchargeTotal: number;
    insuranceAmount: number;
    calculatedAmount: number;
    includedByIncoterm: boolean;
    surcharges: { id: string; concept: string; calculatedAmount: number }[];
  }[];
}

export const CHARGE_METHOD_LABELS: Record<ChargeMethod, string> = {
  CBM: 'Por Volumen (CBM)',
  KG: 'Por Peso (KG)',
  FLAT: 'Monto Fijo',
  MANUAL: 'Manual',
};

export const SURCHARGE_TYPE_LABELS: Record<SurchargeType, string> = {
  PERCENTAGE: 'Porcentaje (%)',
  FLAT: 'Monto Fijo ($)',
};
